/**
 * @generated SignedSource<<b85425814bfc834cdfb6f59b9281201e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDueDate_todo$data = {
  readonly canSchedule: {
    readonly value: boolean;
  };
  readonly dueDate: DateString  | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDueDateModal_todo">;
  readonly " $fragmentType": "TodoDueDate_todo";
};
export type TodoDueDate_todo$key = {
  readonly " $data"?: TodoDueDate_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDueDate_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoDueDate_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoDueDateModal_todo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canSchedule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "86fbfd85892e6d3e4ee3a4a19bcced6e";

export default node;
